import CourseDetails from "@/components/course-details/course-details";
import SEO from "@/components/seo/seo-metadata";

import getDuration from "@/helpers/get-duration";
import { videoDataHelper } from "@/helpers/video-data-helper";
import { getData } from "@/utils/academy-stack";
import { useEffect } from "react";
import { sendUserInfoToLytics } from "@/utils/p13n";

export default function LessonPage({ pageData, videoEntry, videoConfig }) {
  const duration =
    videoEntry?.time_to_read ||
    getDuration(videoEntry?.video_lesson[0]?.duration);

  const videoData = {
    file: videoEntry?.video_lesson[0]?.sources[0]?.file,
    image:
      videoEntry?.lesson_thumbnail?.url || videoEntry?.video_lesson[0]?.image,
    title: videoEntry?.title,
  };

  const swifTags = [];

  swifTags.push(
    {
      class: "swiftype",
      name: "tags",
      content: "lesson",
      "data-type": "string",
    },
    {
      class: "swiftype",
      name: "entry_uid",
      content: pageData.uid,
      "data-type": "string",
    },
    {
      class: "swiftype",
      name: "title",
      content: videoEntry?.title,
      "data-type": "string",
    },
    {
      class: "swiftype",
      name: "image",
      content: videoEntry?.lesson_thumbnail
        ? videoEntry?.lesson_thumbnail?.url
        : pageData.thumbnail?.url,
      "data-type": "enum",
    },
    {
      class: "swiftype",
      name: "duration",
      content: duration,
      "data-type": "enum",
    }
  );

  pageData.taxonomies.map((el) => {
    swifTags.push({
      class: "swiftype",
      name: "tags",
      content: el.term_uid,
      "data-type": "string",
    });
  });

  let pageMeta = {
    title: `${videoEntry?.title}`,
    url: `${pageData?.url}`,
  };

  // useEffect(() => {
  //   (async () => {
  //     await updateUserActivity({ courseEntryUid: pageData.uid, lessonEntryUid: videoEntry.uid });
  //   })();
  // }, []);

  useEffect(() => {
    let userData = localStorage.getItem("user");
    if (userData) {
      const parsedData = JSON.parse(userData);
      if (parsedData?.email) {
        sendUserInfoToLytics(
          parsedData.uid,
          parsedData.role,
          parsedData.firstName,
          parsedData.lastName,
          parsedData.email
        );
      }
    }
  }, []);

  return (
    <>
      <SEO
        seoOGMeta={pageData.opengraph}
        pageData={pageMeta}
        swifTags={swifTags}
        pathPrefix="/courses"
        noindex={pageData?.opengraph?.no_index}
      />
      <div className="mh-100">
        <CourseDetails
          pageData={pageData}
          videoEntry={videoEntry}
          videoConfig={videoConfig}
          videoData={videoData}
          isStandaloneCourse={false}
        />
      </div>
    </>
  );
}

export async function getServerSideProps(context) {
  const referenceFields = [
    "chapters.lessons.lessons",
    "related_courses.reference",
  ];

  const courseURL = context.params.course;
  const lessonURL = context.params.lessons;

  const condition = [{ key: "url", value: `/${courseURL}` }];
  const condition1 = [{ key: "url", value: `/${lessonURL}` }];

  const pageContext = context;

  try {
    let pageData = await getData(
      "course_details",
      referenceFields,
      condition,
      null,
      true,
      pageContext
    );
    // let lessonData = await get("lessons", referenceFields, condition1);

    const { videoConfig, videoEntry } = videoDataHelper(
      pageData[0][0],
      lessonURL
    );
    const isStandaloneCourse = pageData[0][0].is_standalone;

    if (videoEntry.length) {
      if (isStandaloneCourse) {
        return { notFound: true };
      }
      return {
        props: {
          pageData: pageData[0][0],
          videoEntry: videoEntry[0],
          videoConfig: videoConfig,
          // lessonData: lessonData[0][0]
        },
      };
    } else {
      return { notFound: true };
    }
  } catch (error) {
    return { notFound: true };
  }
}
